import {MediaFile, Money, useProductOptions} from '@shopify/hydrogen';
import {MediaEdge} from '@shopify/hydrogen/storefront-api-types';
import {useState} from 'react';
import {IconPlus} from '~/components';
import {Modal} from '../Modal.client';
import {DATA_TEST_IDS} from '~/lib/const';

export function ProductDetail({
  media,
  title,
  content,
  longDescription,
}: {
  media: MediaEdge['node'][];
  title: string;
  content: string;
  longDescription?: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const {selectedVariant} = useProductOptions();
  const isOnSale =
    // @ts-ignore
    selectedVariant?.priceV2?.amount <
      // @ts-ignore
      selectedVariant?.compareAtPriceV2?.amount || false;

  return (
    <div
      data-testid={DATA_TEST_IDS.PRODUCT_DETAIL}
      className="mt-4 mb-10 lg:mb-10"
    >
      <p
        className="text-16/24 lg:text-18/26"
        dangerouslySetInnerHTML={{__html: content}}
      />

      {longDescription && (
        <button
          data-testid={DATA_TEST_IDS.BUTTON('read-more')}
          type="button"
          className="text-16/20 font-header font-bold tracking-wider border-b-[3px] border-b-blue-500 flex items-center py-1 mt-7 lg:mt-4"
          onClick={() => setIsOpen(true)}
        >
          READ MORE
          <IconPlus className="ml-2 w-3 h-3" />
        </button>
      )}

      <Modal
        classNamePanel={
          'max-w-4xl 3xl:max-w-[1272px] pl-[22px] pr-5 pt-5 pb-[48px] md:p-10'
        }
        isOpen={isOpen}
        onCloseModal={() => setIsOpen(false)}
      >
        <div className="m-0 md:ml-[93px] md:mr-[91px] md:-mt-[46px] md:mb-[208px]">
          <div className="flex space-x-[23px] md:space-x-[63px] items-center">
            <MediaFile
              alt={title}
              tabIndex="0"
              className={`aspect-square fadeIn object-cover w-[159px] bg-gray-200`}
              data={media[0]}
              // @ts-ignore
              options={{
                crop: 'center',
                scale: 2,
              }}
            />

            <div className="text-20/27 font-header font-bold">
              <div className="w-full max-w-[463px]">{title.toUpperCase()}</div>

              <div className="mt-[32px] md:mt-4 flex">
                {selectedVariant && (
                  <>
                    <Money
                      withoutTrailingZeros
                      data={selectedVariant.priceV2!}
                      as="span"
                    />
                    {isOnSale && (
                      <div className="ml-[38px] text-gray-400 line-through">
                        <Money
                          withoutTrailingZeros
                          data={selectedVariant.compareAtPriceV2!}
                          as="span"
                          className="opacity-50 strike"
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <div
            data-testid={DATA_TEST_IDS.LONG_DESCRIPTION}
            className="text-18/26 mt-[51px] md:mt-[78px]"
          >
            {longDescription}
          </div>
        </div>
      </Modal>
    </div>
  );
}
